import './App.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Project from './pages/Project';
import Delayed from './components/Delayed';
import SplashScreen from './components/SplashScreen';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import { useMotionValue } from 'framer-motion';
import { useSubscriber } from './helpers/functions/hooks/events';
import { useEffect } from 'react';

const App = (): JSX.Element => {
    let scrollYProgress = useMotionValue(0);

    const remove = useSubscriber('scrollProgressRef', (progress: CustomEvent<any>) => { 
        const motionValue = progress.detail;
        scrollYProgress.setWithVelocity(motionValue.prev, motionValue.current, motionValue.updatedAt - motionValue.prevUpdatedAt);
    }); 

    useEffect(() => {
        if (window.location.hash && window.location.pathname === '/') {
            window.history.replaceState("", document.title, window.location.pathname);
        }
        return remove;
    }, [remove])

    return (
        <Delayed delay={4400} fallback={<SplashScreen />}>
            <div className="main-background">
                <svg xmlns="http://www.w3.org/2000/svg" width="1102" height="740" viewBox="0 0 1102 740" fill="none" id="blurcircle">
                    <g filter="url(#filter0_f_89_16)">
                        <path d="M901.204 369.994C901.204 582.068 753.491 753.987 556.565 753.987C359.64 753.987 200 582.068 200 369.994C200 157.92 359.64 -14 556.565 -14C753.491 -14 901.204 180.567 901.204 369.994Z" fill="#030028" />
                    </g>
                    <defs>
                        <filter id="filter0_f_89_16" x="0" y="-214" width="1101.2" height="1167.99" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_89_16" />
                        </filter>
                    </defs>
                </svg>
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        <Route path='/projects/:project' element={<Project />} />
                        <Route path='/' element={<HomePage />} />
                    </Routes>
                    <Navbar scrollYProgress={scrollYProgress} />
                </BrowserRouter>
            </div>
        </Delayed>
    );
}

export default App;
